import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Car, Plane, Shield, ChefHat, ArrowRight } from 'lucide-react';
import { services } from '../mock/mockData';

const Services = () => {
  const iconMap = {
    Car: Car,
    Plane: Plane,
    Shield: Shield,
    ChefHat: ChefHat
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-12 md:py-20 bg-gradient-to-b from-amber-50 via-orange-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            Premium Services
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Luxury transportation and exclusive services tailored to your needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border-2 border-transparent hover:border-amber-600"
              >
                {/* Service Image */}
                <div className="relative h-40 md:h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-3 md:bottom-4 left-3 md:left-4 bg-[#6B0B0B] p-2 md:p-3 rounded-lg">
                    <IconComponent className="text-white" size={20} />
                  </div>
                </div>

                <CardHeader className="p-4 md:p-6">
                  <CardTitle className="text-lg md:text-xl text-gray-900">{service.title}</CardTitle>
                  <CardDescription className="text-sm md:text-base text-gray-600">
                    {service.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="p-4 md:p-6 pt-0">
                  <div className="text-base md:text-lg font-bold text-[#6B0B0B] mb-3 md:mb-4">
                    {service.price}
                  </div>
                  <Button 
                    onClick={scrollToContact}
                    variant="outline"
                    className="w-full border-[#6B0B0B] text-[#6B0B0B] hover:bg-[#6B0B0B] hover:text-white transition-all duration-300 group-hover:bg-[#6B0B0B] group-hover:text-white py-5 text-sm md:text-base"
                  >
                    Inquire Now
                    <ArrowRight size={16} className="ml-2" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-12 md:mt-16 bg-gradient-to-r from-red-50 to-orange-50 rounded-xl md:rounded-2xl p-6 md:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">
              Need Something Custom?
            </h3>
            <p className="text-base md:text-lg text-gray-700 mb-5 md:mb-6 px-4">
              We offer bespoke packages tailored to your specific requirements. Whether it's a corporate event, wedding, or special celebration, we've got you covered.
            </p>
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="w-full sm:w-auto bg-[#6B0B0B] hover:bg-[#8B1515] text-white px-6 md:px-8 py-5 md:py-6 text-base md:text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Contact Us for Custom Packages
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
